import React from "react";
import { NextPage } from "next/types";
import { useAnimation as UseAnimation, motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

import Image from "next/image";
import Link from "next/link";

import Web1 from "@/public/static/images/web-c-01.png";
import Web2 from "@/public/static/images/web-c-02.png";
import Web3 from "@/public/static/images/web-c-03.png";

import Web4 from "@/public/static/images/web-c-04.png";
import Web5 from "@/public/static/images/web-c-05.png";
import Web6 from "@/public/static/images/web-c-06.png";
import Web7 from "@/public/static/images/web-c-07.png";
import Web8 from "@/public/static/images/web-c-08.png";

import WebPJ1 from "@/public/static/images/w-01.png";
import WebPJ2 from "@/public/static/images/w-02.png";
import WebPJ3 from "@/public/static/images/w-03.png";
import WebPJ4 from "@/public/static/images/w-04.png";
import WebPJ5 from "@/public/static/images/w-05.png";
import WebPJ6 from "@/public/static/images/w-06.png";

import WebPJ7 from "@/public/static/images/w-07.png";

function web_application() {
  const img: any = "/static/images/s-web.png";

  const imgAnimation = UseAnimation();

  const handleMouseMove = (e: any) => {
    const { clientX, clientY } = e;
    const moveX = clientX - window.innerWidth / 2;
    const moveY = clientY - window.innerHeight / 2;
    const offsetFactor = 15;
    imgAnimation.start({
      x: moveX / offsetFactor,
      y: moveY / offsetFactor,
    });
  };

  return (
    <div className="wrapper">
      <Header />
      <section className="key_visual">
        <motion.img
          // animate={imgAnimation}
          // onMouseMove={(e) => handleMouseMove(e)}
          src={img}
          alt="Website / Application"
          loading="lazy"
        />
        <div className="img-bg" />
      </section>

      <section className="sv_content web-content">
        <div className="container">
          <div className="row">
            <div className="col-12 heading-top_content">
              <div className="d-flex justify-content-center">
                <h2>Website / Application</h2>
              </div>
            </div>
            <div className="col-12 sv_content-inner">
              <p className="mb-2">
                ITP Group has researched "Right information in the right place"
                for over 100 years.
              </p>
              <p className="mb-2">
                There has been an increase in transmitting "Right information"
                worldwide using IT technology since 2010. ITP Asia has also
                researched information usage methods using AI and IT technology
                as a professional in Information processing technology and
                Information distribution technology and has developed a proper
                IT system.
              </p>
              <p className="mb-2">
                ITP Asia has in-house developers working with different
                programming languages, like AI and backend system development.
                Also, we are developing full-scratch systems that can meet
                customer needs.
              </p>
              <p className="mb-4">
                We continue developing the most proper "Right place", such as
                AI, CRM, DMS, Website, MA Tool, and iOS/Android Mobile
                Application to provide the best solution responding to the
                client’s needs.
              </p>
              <p className="mb-2">(Example)</p>

              <ul>
                <li>CRM (Customer Relation Management System)</li>
                <li>DMS (Dealer Management System)</li>
                <li>Dealer support application</li>
                <li>Sales support application</li>
                <li>Company Website</li>
                <li>Internal website (For employees)</li>
                <li>Virtual Office</li>
                <li>Customer Survey System Etc.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center web-heading-spr">
              <h1 className="fw-bold">
                Are you tired of{" "}
                <span className="fw-bolder t-yellow">
                  dealing with manual processes,
                </span>
              </h1>
              <h1 className="fw-bold">
                <span className="fw-bolder t-yellow">
                  outdated software, or inefficient workflows
                </span>
              </h1>
              <h1 className="mb-3">
                that are causing unnecessary time-consuming process in your
                business?
              </h1>
              <h2 className="fw-bold t-yellow">
                Why not have an automated software do it for you instead?
              </h2>
              <h2>
                Here are the reasons you may need to know why software is so
                necessary for your business.
              </h2>
            </div>
          </div>
          <div className="row justify-content-md-center mt-5">
            <div className="col-12 col-md-4 card-sv card-web">
              <div className="card h-100 text-center">
                <Image
                  loading="lazy"
                  src={Web1}
                  alt="Increase Efficiency"
                  className="img-fluid mx-auto"
                />
                <div className="card-body">
                  <h2 className="card-title t-yellow">Increase Efficiency</h2>
                  <p>
                    Custom software can be designed to automate repetitive
                    tasks, streamline processes, and reduce the time and effort
                    required to complete them.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-web">
              <div className="card h-100 text-center">
                <Image
                  loading="lazy"
                  src={Web2}
                  alt="Enhance User Experience"
                  className="img-fluid mx-auto"
                />
                <div className="card-body">
                  <h2 className="card-title t-yellow">
                    Enhance User Experience
                  </h2>
                  <p>
                    Custom software or website can be designed to meet the
                    specific needs of the business and its users, providing a
                    more personalized and intuitive user experience.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-web">
              <div className="card h-100 text-center">
                <Image
                  loading="lazy"
                  src={Web3}
                  alt="Scalability"
                  className="img-fluid mx-auto"
                />
                <div className="card-body">
                  <h2 className="card-title t-yellow">Scalability</h2>
                  <p>
                    Custom software or website can be designed to grow with your
                    business and accommodate changing needs and requirements.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center web-heading-spr mb-5">
              <h1 className="fw-bolder t-yellow mb-2">
                Do not let boring tasks hold your business back
                <br />
                Let us help you find the solutions you need to succeed!
              </h1>
              <h2 className="t-white">Here are what we can do support you</h2>
            </div>
          </div>

          <div className="row mb-5 d-flex align-items-center">
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <div className="card-body">
                  <h1 className="t-yellow mb-0">CRM</h1>
                  <h2 className="t-white borderbt mb-3">
                    Customer Relation Management System
                  </h2>
                </div>
                <div className="card-footer t-white mt-5">
                  <p>
                    Grasp the opportunity to advantage your business with CRM or
                    Customer Relation Management System.
                  </p>
                  <p>
                    We customize the platform based on your problems and needs.
                    With our service, you will be able to{" "}
                    <span className="fw-bolder">centralize customer data</span>{" "}
                    that will allow you to access and manage it easier. CRM can
                    also{" "}
                    <span className="fw-bolder">
                      improve customer service, enhance marketing strategy,
                    </span>
                    which will result in increasing sales too.
                  </p>
                  <p className="mb-0">Haven’t have any CRM system yet?</p>
                  <p>Why not let us do it for you now!</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <div className="card-body">
                  <h1 className="t-yellow mb-0">DMS</h1>
                  <h2 className="t-white borderbt mb-3">
                    Dealer Management System
                  </h2>
                </div>
                <div className="card-footer t-white mt-5">
                  <p>
                    Improve relationships with dealers or distributors with DRM
                    or Dealer Relation Management System.
                  </p>
                  <p>
                    We tailor the platform for you to manage your distributors
                    data for any purposes. With our service, you will be able to{" "}
                    <span className="fw-bolder">improve collaboration</span>{" "}
                    with you and your distributors for{" "}
                    <span className="fw-bolder">
                      better sales management and streamlined operations.
                    </span>
                  </p>
                  <p className="mb-0">Haven’t have any DRM system yet?</p>
                  <p>Why not let us do it for you now!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content">
        <div className="container">
          <div className="row mb-5 d-flex align-items-center">
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <div className="card-body">
                  <h1 className="t-yellow mb-0">Internal Web Application</h1>
                  <h2 className="borderbtb mb-3 pb-4 lh-1">
                    Virtual office, Attendance record system, Reception system,
                    Meeting room/Car reservation system
                  </h2>
                </div>
                <div className="card-footer mt-3">
                  <p>
                    Your organization has unique needs, and we definitely
                    understand it.
                  </p>
                  <p>
                    No matter how complicated it is, our team will work closely
                    with you to understand your processes and requirements to
                    ensure that your customized website meets your specific
                    needs.
                  </p>
                  <p>
                    Contact us today and let’s start your website that will
                    enhance your organization process and grow your business.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <div className="card-body">
                  <h1 className="t-yellow mb-0">Company Website</h1>
                  <h2 className="borderbtb mb-3 t-white">.</h2>
                </div>
                <div className="card-footer mt-5">
                  <p>
                    Website plays an important role in today’s digital world. At
                    ITP Asia, we work on your custom website not only to look
                    great, but also drives traffic and leads to your business.
                  </p>
                  <p>
                    With our team of specialists, we provide you comprehensive
                    website development services including responsive design,
                    user experience optimization, search engine optimization,
                    and many more.
                  </p>
                  <p>
                    Let’s get started today and take your online presence to the
                    next level.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row mb-5 d-flex align-items-baseline">
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <div className="card-body">
                  <h1 className="t-yellow mb-0">Dealer & Sales Support</h1>
                  <h2 className="borderbt mb-3 t-white">
                    Mobile application and other tools
                  </h2>
                </div>
                <div className="card-footer mt-5 t-white">
                  <p className="mb-3">
                    Maximize the potential of your dealers and sales team, and
                    help them succeed with our tools and resources. From{" "}
                    <span className="fw-bolder">training and education</span> to{" "}
                    <span className="fw-bolder">
                      marketing and sales support,
                    </span>
                    we’ve got you all covered.
                  </p>
                  <p>
                    Let our team provide you tailored Dealer & Sales Support
                    Tools that respond to your user needs, maintain strong
                    relationships, increase their productivity and performance,
                    and ultimately grow your business.
                  </p>
                  <p>Just contact and let us now.</p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <div className="card-body">
                  <h1 className="t-yellow mb-0">Customer Survey</h1>
                  <h2 className="borderbt mb-3 t-white">System</h2>
                </div>
                <div className="card-footer mt-5 t-white">
                  <p className="mb-3">
                    Get the right opinions from the right platform. Our customer
                    survey system is designed to give you the insights you need
                    to succeed. With us, we design and develop survey system
                    tailored to your business needs, user-friendly, and ensure
                    that all of the process complies with data protection laws
                    and regulations.
                  </p>
                  <p>
                    Contact us today to learn how our customer survey system can
                    help you enhance your customer experience.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center web-heading-spr">
              <h1 className="fw-bolder t-yellow mb-3">
                Customize to solve your problems
              </h1>
              <h2>
                With our experienced team of software development specialists,
                <br />
                we tailor the system that meet your unique needs from full
                scratch
              </h2>
            </div>
          </div>
          <div className="row justify-content-md-center mt-5">
            <div className="col-12 col-md-4 card-sv card-web">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <h1 className="card-title fw-bolder t-yellow mb-3">
                    Proven Experience
                  </h1>
                  <Image
                    loading="lazy"
                    src={Web4}
                    alt="Proven Experience"
                    className="img-fluid mx-auto mb-3"
                  />
                  <p className="mt-4">
                    We have years of experience in developing customized
                    software solutions for clients across various industries.
                    All of our work is the prove of client’s trust for letting
                    us be a part of their new system development.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-web">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <h1 className="card-title fw-bolder t-yellow mb-3">
                    Tailor-Made Solutions
                  </h1>
                  <Image
                    loading="lazy"
                    src={Web5}
                    alt="Tailor-Made Solutions"
                    className="img-fluid mx-auto mb-3"
                  />
                  <p className="mt-4">
                    We understand your unique needs, work closely with you to
                    understand them, and develop software solutions that
                    perfectly match your requirements
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-web">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <h1 className="card-title fw-bolder t-yellow mb-3">
                    Cutting-Edge Technology
                  </h1>
                  <Image
                    loading="lazy"
                    src={Web6}
                    alt="Cutting-Edge Technology"
                    className="img-fluid mx-auto mb-3"
                  />
                  <p className="mt-4">
                    We stays up-to-date with the latest technologies and trends
                    to ensure that we are always providing you with cutting-edge
                    software solutions that will keep you ahead
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-web">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <h1 className="card-title fw-bolder t-yellow mb-3">
                    Collaborative Approach
                  </h1>
                  <Image
                    loading="lazy"
                    src={Web7}
                    alt="Collaborative Approach"
                    className="img-fluid mx-auto mb-3"
                  />
                  <p className="mt-4">
                    We work closely with our clients throughout the entire
                    software development process, from initial consultation to
                    final delivery as we value collaboration and communication
                    throughout the process.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-web">
              <div className="card h-100 text-center">
                <div className="card-body">
                  <h1 className="card-title fw-bolder t-yellow mb-3">
                    Support and Maintenance
                  </h1>
                  <Image
                    loading="lazy"
                    src={Web8}
                    alt="Support and Maintenance"
                    className="img-fluid mx-auto mb-3"
                  />
                  <p className="mt-4">
                    We don't just develop software and leave. We provide ongoing
                    support and maintenance services to ensure that your
                    software continues to function optimally and meets the
                    evolving business needs.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 mt-4">
              <h2 className="text-center mb-0 lh-1">
                At ITP Asia, we do not deliver you just only a completed work,
                <br />
                but we also monitor, support, and suggest solutions <br />
                to optimize your software that meets any of your business goal.
              </h2>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row">
            <div className="col-12 t-white text-center web-heading-spr">
              <h2 className="text-center mb-0 lh-1">
                Technologies go fast, but we work smart and won’t be left
                behind.
                <br />
                Work with us today, let automation ease your daily tasks,
                <br />
                let us make your change!
              </h2>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default web_application;
